<div [editableInStoryblok]="_editable">
	<vp-usp-bar
		[rating]="!hideRatings() && hotelStore.rating()"
		[usps]="usps"
		iconVariant="accent"
	/>
</div>
